export const parseBRLToCents = (value: string | undefined): number => {
    return Number(String(value).replace(/[^\d]/g, ''));
};

export const currencyFormatter = (value: number): string => {
    return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
    }).format(value);
};

export const currencyFormatterToBRL = (value: number | undefined): string => {
    if (!value) return currencyFormatter(0);

    const numberCleared = String(value).replace(/[^\d-]/g, '');

    const num = String(numberCleared).split('');

    const isFirstDigit = num.length === 1;

    if (isFirstDigit) {
        num.splice(-1, 0, '.', '0');
    }

    if (!isFirstDigit) {
        num.splice(-2, 0, '.');
    }

    const number = +num.join('');

    return currencyFormatter(number);
};

export const addZeros = (
    value: number | undefined,
    numberOfZeros: number,
): string => {
    if (!value) return '';
    const numberCleared = String(value).replace(/[^\d]/g, '');
    const num = String(numberCleared);

    return num.padStart(numberOfZeros, '0').slice(-numberOfZeros);
};

export const formatToAccountNumber = (value: number | undefined): string => {
    const account = addZeros(value, 10);
    const numberCleared = String(account).replace(/[^\d]/g, '');
    return numberCleared.replace(/[0-9]$/gim, '-$&');
};
